import React from 'react'

const TextInputWrapper = React.forwardRef((props, ref) => (
  <div className='form-group row'>
    <label className='facility-label col-lg-5' htmlFor={props.name}>{props.label}</label>
    <div className='col-lg-7'>
      <input 
        className='form-control' 
        ref={ref}
        name={props.name}
        onChange={props.onChange}
        disabled={props.disabled}
      />
    </div>
  </div>
))

export default TextInputWrapper
